import { CopilotChat } from "@/components/chat/CopilotChat";
import { APP_NAME } from "@/config/constants";
import { getModelSelection } from "@/lib/readModelSelection";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/")({
  component: HomePage,
  head: () => ({
    meta: [
      {
        title: APP_NAME,
      },
    ],
  }),
  loader: async () => {
    const modelData = await getModelSelection();
    return { modelData };
  },
});

function HomePage() {
  const { modelData } = Route.useLoaderData();

  return (
    <div className="h-full w-full">
      <CopilotChat
        textModel={modelData.textModel}
        imageModel={modelData.imageModel}
        imageMode={modelData.imageMode}
      />
    </div>
  );
}
